import { MenuItem } from "@mui/material";
import { SelectValidator } from "react-material-ui-form-validator";

export function getEnumDropdown<T>(label: string, name: string, _type: T, value: any, handleChange: (event: any) => void, isRequired?: boolean, variant?: string) {
    var type = _type as any;
    const values = Object.values(_type as any);

    var menuItems = values.filter((v) => isNaN(Number(v))).map((_value, index) =>
        <MenuItem key={`${label}_${name}_${type[_value as string]}`} value={type[_value as string]}>{_value as string}</MenuItem>
    );

    return <>
        <SelectValidator
            value={((value ? Number(value) : value))}
            onChange={handleChange}
            required={!!isRequired}
            label={label}
            name={name}
            fullWidth
            validators={isRequired ? ['required'] : []}
            errorMessages={isRequired ? ['This field is required'] : []}
            variant={variant || "filled"}
            InputLabelProps={{
                shrink: !!value,
            }}>

            {menuItems}

        </SelectValidator>
    </>
}